import { Component, HostListener } from '@angular/core';
import { State, StateList } from 'src/app/shared/state-list';
import { Router } from '@angular/router';
import { MyListingsService } from '../../services/my-listings.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { StripeService } from '../../services/stripe.service';
import { ListingCheckoutService } from '../../services/listing-checkout.service';
import { ToastService, ToastType } from '../../services/toast.service';
import { AppState } from 'src/app/app.state';
import constants from 'src/constants.json';
import { ActivityLoggerService } from 'src/app/services/activity-logger.service';
import { UserState } from 'src/state/user.state';

interface Type {
  value: string;
  viewValue: string;
}
@Component({
  selector: 'app-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.css'],
})
export class ReviewComponent {
  StateOrProvince: string;
  stateList: State[] = StateList;
  streetAddress: string = '';
  zipcode: string = '';
  city: string = '';
  addressFlag: boolean = false;
  isSubmitted: boolean = false;
  reviewData: {};
  ownerShipType: any;
  details: any;
  checkArray: string[] = [];

  constructor(
    private router: Router,
    public localStorageService: LocalStorageService,
    public myListingsService: MyListingsService,
    public StripeService: StripeService,
    public listingCheckoutService: ListingCheckoutService,
    public toastService: ToastService,
    public appState: AppState,
    private activityLoggerService: ActivityLoggerService,
    private userState: UserState,
  ) { }

  historyState: any;
  selectedPlan: any;
  selectedAddons = [];
  selectedMls = [];
  checkBoxList = [
    {
      name: 'I am a Real Estate Licensee in one or more states.',
      id: '1',
      isChecked: false,
    },
    {
      name: 'I want to list this property For Rent.',
      id: '2',
      isChecked: false,
    },
    {
      name: 'Property was built before 1978',
      id: '3',
      isChecked: false,
    },
  ];
  ownType: Type[] = [
    { value: 'Individual Owned', viewValue: 'Individual Owned' },
    { value: 'Corporate Owned', viewValue: 'Corporate Owned' },
  ];

  totalAmount: number;
  myListingId: string;
  isLoader: boolean = false;
  listingCheckoutUserId: any;
  listingCheckoutEnabled: boolean = false;

  isScreenWidthLarge: boolean = false;

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this.isScreenWidthLarge = window.innerWidth > 768;
  }

  ngOnInit(): void {

    this.isScreenWidthLarge = window.innerWidth > 768;
    let currentCompany = this.appState.companyInfoValue;

    this.historyState = history.state;
    if (!this.historyState || !this.historyState.address || this.historyState.isPaymentDone || currentCompany?.sellSideConfig?.hidePlanSelection) {
      this.router.navigateByUrl('/my-listing');
      return;
    }

    this.myListingId = this.historyState.myListingId ? this.historyState.myListingId : this.localStorageService.get('myListingId') ? this.localStorageService.get('myListingId') : null;

    this.totalAmount = this.historyState.totalAmount;
    this.selectedPlan = this.historyState.plansData;
    this.selectedAddons = this.historyState.addOnsData;
    this.selectedMls = this.historyState.mlsData;

    if (currentCompany?.sellSideConfig && currentCompany?.sellSideConfig?.listingServiceProvider == 'ListingCheckout') {
      this.listingCheckoutEnabled = true;
    }

    this.listingCheckoutService.GetListingCheckoutToken().subscribe(
      {
        next: (res) => {

          if (res && res.access_token) {
            this.localStorageService.set('lcAccessToken', res.access_token);
            this.createListingCheckoutAccount();
          } else {
            console.log('GetListingCheckoutToken Fails!!!!');
          }
        },
        error: (err) => {
          console.log("GetListingCheckoutToken err : ", err);
        }
      }
    );
  }

  createListingCheckoutAccount() {
    if (this.listingCheckoutEnabled) {
      let input = {
        "email": this.userState?.getUserDetails?.userName,
        "firstName": this.userState?.getUserDetails?.firstName,
        "lastName": this.userState?.getUserDetails?.lastName
      }
      this.listingCheckoutService.CreateAccount(input).subscribe(
        {
          next: (res) => {

            if (res && res.userId) {
              this.listingCheckoutUserId = res.userId;
            } else {
              console.log('CreateAccount Fails!!!!');
            }
          },
          error: (err) => {
            console.log("CreateAccount err : ", err);
          }
        }
      );
    }
    else {
      this.listingCheckoutUserId = "NotApplicable";
    }
  }

  back() {
    this.router.navigateByUrl('/plans', {
      state: this.historyState,
    });

  }

  checkoutStripe(stripeId, stripeUrl) {

    let updateInput = {
      updatedDate: new Date(),
      stripeCheckoutSessionId: stripeId,
      listingCheckoutUserId: this.listingCheckoutUserId.toString(),
      // listingCheckoutToken: this.localStorageService.get('lcAccessToken')
    }

    if (!this.historyState.completedIndex || this.historyState['completedIndex'] < 3) {
      updateInput['stage'] = 3;
      if (this.historyState.stageName) {
        if (this.historyState.stageName.split(',').indexOf('Review') <= -1) {
          updateInput["stageName"] = "Review" + "," + this.historyState.stageName;
        }
      }
    }

    this.myListingsService.UpdateListing(this.myListingId, updateInput).subscribe(
      {
        next: (res) => {
          if (!this.historyState.completedIndex || this.historyState['completedIndex'] < 3) {
            this.historyState['completedIndex'] = 3;
          }
          this.historyState.stageName = updateInput["stageName"];

          this.isLoader = false;

          window.open(stripeUrl, "_self");
        },
        error: (err) => {
          console.log('UpdateListing err!!!!');
          this.isLoader = false;
          console.log(err);
        }
      }
    );
  }
  // addressAutopopulate() {

  //   console.log('form', this.reviewForm.value.checks);

  //   if (this.reviewForm.value.checks) {
  //     this.streetAddress = this.historyState.StreetAddress;
  //     this.city = this.historyState.City;
  //     this.StateOrProvince = this.historyState.StateOrProvince;
  //     this.zipcode = this.historyState.PostalCode;
  //     this.reviewForm.patchValue({
  //       streetVal: this.streetAddress,
  //       stateVal: this.StateOrProvince,
  //       cityVal: this.city,
  //       zipCodesVal: this.zipcode,
  //     })
  //     console.log("checked");
  //   } else {
  //     console.log("unchecked");
  //     this.resetShippingForm();
  //   }
  // }

  // resetShippingForm() {
  //   this.reviewForm.get('streetVal').reset();
  //   this.reviewForm.get('stateVal').reset();
  //   this.reviewForm.get('cityVal').reset();
  //   this.reviewForm.get('zipCodesVal').reset();
  // }
  // selectedValues(name){
  //   if(this.reviewForm.value.checkbox){
  //     this.checkArray.push(name);
  //   }else{
  //    this.checkArray= this.checkArray.filter(item => item !== name)
  //   }
  //   console.log("checkboxesSelected:", this.checkArray);
  // }
  // removeDuplicates(arr) {
  //   arr.filter((item,
  //     index) => arr.indexOf(item) === index);

  //   console.log('duplicateRemoved', arr);
  // }

  continue() {
    this.isLoader = true;
    // this.isSubmitted = true;
    // this.streetAddress = this.reviewForm.value.streetVal; // commentted since functionality is removed
    // this.city = this.reviewForm.value.cityVal;
    // this.StateOrProvince = this.reviewForm.value.stateVal;
    // this.zipcode = this.reviewForm.value.zipCodesVal;
    // this.ownerShipType = this.reviewForm.value.drop;
    // if (this.checkArray.length > 0) {
    //   this.removeDuplicates(this.checkArray);
    // }
    // this.details = this.checkArray;
    // if (this.streetAddress && this.city && this.StateOrProvince && this.zipcode && this.ownerShipType && this.ownerShipType) {
    //   this.reviewData = {
    //     shippingStreet: this.streetAddress,
    //     shippingCity: this.city,
    //     shippingState: this.StateOrProvince,
    //     shippingZipcode: this.zipcode,
    //     ownerShipType: this.ownerShipType,
    //     details: this.details.toString()
    //   }
    //   console.log("reviewData", this.reviewData);
    //   this.historyState['reviewData'] = this.reviewData;
    //   console.log("historyState", this.historyState)

    this.myListingsService.GetListingsById(this.myListingId).subscribe({
      next: (res) => {
        if (res && res.stripePaymentStatus == 'paid') {
          this.toastService.toast('Payment already completed for this listing', ToastType.Warning);
          this.isLoader = false;
        } else {

          let input = {
            'product_name': this.selectedPlan.name,
            'unit_amount': (this.totalAmount * 100).toString(),
            'quantity': '1',
            'client_reference_id': this.myListingId,
            'cancel_url': 'https://' + this.appState.companyInfoValue?.sellBaseUrl + '/my-listing?listingId=' + this.myListingId + '&status=cancel',
            'success_url': 'https://' + this.appState.companyInfoValue?.sellBaseUrl + '/my-listing?listingId=' + this.myListingId + '&status=success',
            'customer_email': this.userState?.getUserDetails?.userName
          };
          let userType = this.userState?.getUserDetails?.userType;
          if (userType == 'investor') {
            let userId = this.userState?.getUserDetails?.id;
            let loggerParams = {
              category: constants.LOGGER.listMyProperty.category,
              action: constants.LOGGER.listMyProperty.action.proceedPayment.key,
              data: {
                userId: userId,
                propertyId: this.historyState.listingDetails?.PMXPropertyId
              }
            };
            this.activityLoggerService.updateActivityLog(loggerParams).subscribe({
              next: (res) => { },
              error: (err) => {
                console.log(err);
              },
            });
          }
          this.StripeService.StripeCheckout(input).subscribe(
            {
              next: (res) => {
                if (res && res.url) {
                  console.log("res.url :", res.url);
                  this.checkoutStripe(res.id, res.url);
                }
              },
              error: (err) => {
                console.log('StripeCheckout err!!!!');
                this.isLoader = false;
                console.log(err);
              }
            }
          );
          // } else {
          //   console.log('mandatory fields not filled!!!');
          // }
        }
      },
      error: (err) => {
        this.isLoader = false;
        console.log('GetListingsById err : ', err);
      },
    });
  }
}

